import { registerLocaleData } from '@angular/common';
import localeEC from '@angular/common/locales/es-EC';
import { LOCALE_ID, NgModule } from '@angular/core';
import { CoreModule } from './core/core.module';
import { ForbiddenViewComponent } from './forbidden/forbidden.component';
import { KhuyanaRoutingModule } from './khuyana-routing.module';
import { KhuyanaComponent } from './khuyana.component';
import { LoginViewComponent } from './login/login.component';
import { MainModule } from './main/main.module';
import { KhuyanaMainStoreModule } from './store/khuyana-store.module';

registerLocaleData(localeEC);

@NgModule({
  declarations: [KhuyanaComponent, ForbiddenViewComponent, LoginViewComponent],
  imports: [
    CoreModule,
    MainModule,
    KhuyanaRoutingModule,
    KhuyanaMainStoreModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'es-EC',
    },
  ],
  bootstrap: [KhuyanaComponent],
})
export class KhuyanaModule {}
